<template>
  <Modal v-model="visible" :footer-hide="true" :transfer="transfer" :mask-closable="false" class="my-modal"
    :class="className" width="360px">
    <p class="title">请输入图形验证码</p>
    <div class="code-wrap">
      <input class="input-code" v-model="formData.code" type="text" placeholder="请输入图形验证码">
      <img v-if="imgTime" :src="'/system/info/createCode?t=' + imgTime" class="code-img" @click.stop="resetCode()" />
    </div>
    <div class="ivu-modal-footer">
      <Button type="text" @click="cancel">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    transfer: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      error: false,
      visible: false,
      showStatus: false,//是否需要显示图形验证码
      imgTime: '',//时间戳
      requestUrl: '',
      formData: {
        mobile: '', code: ''
      }
    };
  },
  watch: {},
  methods: {
    async open({ params, requestUrl = '/system/info/sendCode' }) {
      this.requestUrl = requestUrl
      this.formData.code = '';
      this.formData = {
        ...this.formData,
        ...params
      }
      this.showStatus = await this.getStatus();
      if(!this.showStatus) {
        this.ok();
        return;
      }
      this.imgTime = new Date().getTime()
      this.visible = true;
    },
    // 获取是否需要显示图形验证码
    getStatus() {
      return this.$http({
        type: "GET",
        url: "/system/info/needImageCode",
        data: {},
      }).then(res => {
        return res.data
      })
    },
    // 重置验证码
    resetCode() {
      this.imgTime = new Date().getTime();
    },
    cancel() {
      this.visible = false;
    },
    ok() {
      if (this.showStatus && this.formData.code.length != 4) {
        this.resetCode();
        return this.$notice.error('请输入正确的图形验证码');
      }
      this.$http({
        url: this.requestUrl,
        type: 'GET',
        data: this.formData
      }).then(res => {
        console.log(res)
        if (res.data) {
          this.$emit('success', this.formData.code)
          this.$notice.success('已发送');
          this.visible = false;
        }
      }).catch(() => {
        this.resetCode();
      })

    },
  },
};
</script>
<style lang="scss" scoped>
.my-modal {
  /deep/.ivu-icon-ios-close {
    color: #8A9095 !important;
    font-size: 36px !important;
    font-weight: 600;
  }

  /deep/ .ivu-modal-content {
    overflow: hidden;
    border-radius: 10px;
  }


  /deep/ {
    .ivu-modal-body {
      font-size: 13px;
    }

    .code-wrap {
      position: relative;
      margin: 0 0 30px;
      width: 300px;
      height: 48px;
      line-height: 48px;
      background: #F7F8FA;
      border-radius: 4px 4px 4px 4px;

      .input-code {
        background: transparent;
        width: calc(100% - 15px);
        height: 100%;
        margin-left: 15px;
      }

      .code-img {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 80px;
        height: 30px;
        cursor: pointer;
      }
    }

    .ivu-modal-footer {
      .ivu-btn {
        width: 120px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #E3E5E8;
        font-size: 14px;
        color: #727C8E;
      }

      .ivu-btn+.ivu-btn {
        margin-left: 20px;
        color: #FFFFFF;
        border: transparent;

      }
    }
  }

  .title {
    padding: 30px 0 15px;
    font-size: 20px;
    font-weight: 600;
    color: #3C464F;
    line-height: 28px;
    text-align: center;
  }
}
</style>
